module.exports = __webpack_public_path__ + "img/35.e14ef396.jpg";